import React, { useState, useRef } from 'react';
import { Button, Card, CardBody, FormGroup, Label, Row, Col, Input } from 'reactstrap';
import { Formik, Field, Form } from 'formik';
import { useParams } from 'react-router';
import * as Yup from 'yup';
import Dropzone from 'react-dropzone';
import { toast } from 'react-toastify';
import FormikInputField from 'components/common/Fields/FormikInputField';
import useAxios from 'hooks/useAxios';
import Loader from 'components/Loader';
import PurchaseOrderComments from 'pages/PurchaseOrder/PurchaseOrderComments';
import { ModuleAccess } from 'utils/moduleaccess';


const validationSchema = Yup.object({
    comment: Yup.string().required('Comment is required'),
});

let blobFiles = [];

const Attachments = ({  }) => {
    const API = useAxios();
    // const { coveredEntityID, tenantID } = selectedCoveredEntity;
    const [submitting, setSubmitting] = useState(false);
    const [commentID, setCommentID] = useState(-1);
    const [files, setFiles] = useState([]);
    const [comment, setComment] = useState('');
    const [refetch, setRefetch] = useState(0);
    const formikRef = useRef();
    const [initialValues, setInitialValues] = useState({
        comment: '',
        files: [],
    });
    const addComment = async (payload, actions) => {
        // try {
        //     let url = `/${tenantID}/Comments`,
        //         variables = { ...payload, ceid: coveredEntityID };

        //     url = `${url}/AddProgramComment`;
        //     variables.commentId = commentID;

        //     const data = await API.post(url, variables, {
        //         headers: {
        //             'Content-type': 'multipart/form-data',
        //         },
        //         hideLoader: true,
        //     });
        //     if (data.status === 200) {
        //         setFiles([]);
        //         blobFiles = [];
        //         toast.success('Comment added successfully!');
        //         actions.resetForm();
        //         setSubmitting(false);
        //         // onClose();
        //         const min = 1;
        //         const max = 100;
        //         const rand = min + Math.random() * (max - min);
        //         setInitialValues({
        //             comment: '',
        //             files: [],
        //         });
        //         setRefetch(rand);

        //     } else {
        //         setSubmitting(false);
        //         setFiles([]);
        //         blobFiles = [];
        //     }
        // } catch (error) {
        //     console.log(error, 'error');
        //     setSubmitting(false);
        // }
    };

     const hasPermission = (code) => {
          return ModuleAccess("ADT", code);
      }

    const handleSubmit = async (values, actions) => {
        const { comment } = values;
        const { setErrors } = formikRef.current;
        if (!comment.trim()) return setErrors({ comment: 'Enter valid comment' });
        const fileObject = {};
        files.map((f, i) => {
            fileObject['file' + (i + 1)] = f;
            return f;
        });
        setSubmitting(true);
        addComment({ comment, ...fileObject }, actions);
    };

    const fileToDataUri = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                resolve(event.target.result);
            };
            reader.readAsDataURL(file);
        });

    const handleFiles = (f) => {
        setFiles([...f]);
        let comments = {};
        comments.files = [...files, ...f];
        let spData = { ...initialValues, ...comments };
        setInitialValues(spData);
    };

    const onHandleFileChange = (e) => {
        const files = e;
        handleFiles(files);
        files.forEach((data) => {
            fileToDataUri(data).then((dataUri) => {
                blobFiles.push(dataUri);
            });
        });
    };
    const onCommentEdit = (row) => {
        if (row) {
            let comments = {};
            comments.comment = row.comments;
            setComment(row.comments);
            setCommentID(row.commentID);
            let spData = { ...initialValues, ...comments };
            setInitialValues(spData);
        }
    }

    const handleComment = ({ target: { value } }) => {
        setComment(value);
        let comments = {};
        comments.comment = value;
        let spData = { ...initialValues, ...comments };
        setInitialValues(spData);
    };
    const MaxSize = 5242880;

    const ErrorMessage = ({ children }) => (
        <div
            style={{
                fontStyle: 'italic',
                color: 'red',
            }}
        >
            {children}
        </div>
    )

    return (
        <>
            {/* {hasEditable && ( */}
                <div className='py-2'>
                    {submitting && <Loader opacity={0.01} color='black' />}
                    {/* <CardBody> */}
                        <Formik
                            // initialValues={initialValues}
                            // enableReinitialize={true}
                            // onSubmit={handleSubmit}
                            // innerRef={formikRef}
                            children={(props) => {
                                return (
                                    <Form>
                                        <Row>
                                            <Col sm='6'>
                                                <FormGroup>

                                                    <Field
                                                        id='Comment'
                                                        name='comment'
                                                        type='textarea'
                                                        maxlength='250'
                                                        component={FormikInputField}
                                                        label='Comment'
                                                        placeholder='Comment'
                                                        value={comment}
                                                        onKeyUp={handleComment}
                                                        required
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col sm='6'>
                                                <FormGroup>
                                                    <Label>Attachment</Label>
                                                    <Dropzone onDrop={onHandleFileChange} multiple={false}>
                                                        {({
                                                            getRootProps,
                                                            getInputProps,
                                                            isDragActive,
                                                        }) => (
                                                            <section
                                                                className={`drop-zone ${isDragActive ? 'active' : ''
                                                                    }`}
                                                            >
                                                                <div {...getRootProps()}>
                                                                    <input {...getInputProps()} />
                                                                    <div className='browse'>
                                                                        <span>Drag and drop attachment or</span>
                                                                        <span className='highlight'>Browse</span>
                                                                    </div>
                                                                </div>
                                                            </section>
                                                        )}
                                                    </Dropzone>

                                                    {files?.length > 0 && (
                                                        // return <div key={item.name}>{item.name}</div>
                                                        <div>
                                                            {files.map((item) => {
                                                                return <div key={item.name}>{item.size > MaxSize ? (
                                                                    <ErrorMessage>
                                                                        {'File attached should not be greater than 5MB'}
                                                                    </ErrorMessage>
                                                                ) : item.name}</div>;
                                                            })}
                                                        </div>
                                                    )}

                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <div className='d-flex justify-content-end align-items-center'>
                                            <div>
                                                <Button
                                                    color='primary'
                                                    type='submit'
                                                    size='sm'
                                                    disabled={submitting}
                                                    hidden={!(hasPermission('AD'))}

                                                >
                                                    Add
                                                </Button>
                                            </div>
                                        </div>
                                    </Form>
                                );
                            }}
                        ></Formik>

                    {/* </CardBody> */}
                </div>
            {/* )} */}
            <hr/>
            <Card className='border-0 rounded-bottom-1 mt-3 table-card'>
                <CardBody>
                    {/* <ProgramComment
                        tenantID={tenantID}
                        coveredEntityID={coveredEntityID}
                        text='Comments'
                        onCommentEdit={onCommentEdit}
                        refetch={refetch}
                    /> */}
                    <PurchaseOrderComments/>

                </CardBody>
            </Card>
        </>
    );
};

export default Attachments;
